 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React, {useMemo} from 'react'
import {commitLocalUpdate, usePreloadedQuery} from 'react-relay'
import useSearchFilter from '~/hooks/useSearchFilter'
import getNonNullEdges from '~/utils/getNonNullEdges'
import SendClientSideEvent from '~/utils/SendClientSideEvent'

import useAtmosphere from '../hooks/useAtmosphere'

import SearchQueryId from '../shared/gqlIds/SearchQueryId'
import Checkbox from './Checkbox'
import {EmptyDropdownMenuItemLabel} from './EmptyDropdownMenuItemLabel'
import Menu from './Menu'
import MenuItem from './MenuItem'
import MenuItemLabel from './MenuItemLabel'
import {SearchMenuItem} from './SearchMenuItem'
import TypeAheadLabel from './TypeAheadLabel'

const StyledCheckBox = styled(Checkbox)({
  marginLeft: -8,
  marginRight: 8
})
const StyledMenuItemLabel = styled(MenuItemLabel)({})

const StyledMenu = styled(Menu)({
  maxWidth: '100%'
})












const MAX_PROJECTS = 10

const getValue = (item) => {
  return item.fullPath || 'Unknown Project'
}

const GitLabScopingSearchFilterMenu = (props) => {
  const {menuProps, queryRef} = props
  const query = usePreloadedQuery(
    graphql`
      query GitLabScopingSearchFilterMenuQuery($teamId: ID!, $meetingId: ID!) {
        viewer {
          meeting(meetingId: $meetingId) {
            id
            ... on PokerMeeting {
              gitlabSearchQuery {
                selectedProjectsIds
                queryString
              }
            }
          }
          teamMember(teamId: $teamId) {
            integrations {
              gitlab {
                api {
                  query {
                    projects(
                      ids: null
                      membership: true
                      first: 100
                      sort: "latest_activity_desc"
                      search: "" # search tells Relay this query differs to the GitLabScopingSearchResults query
                    ) {
                      edges {
                        node {
                          ... on _xGitLabProject {
                            __typename
                            id
                            fullPath
                            path
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
    queryRef
  )

  const nullableEdges =
    _nullishCoalesce(_optionalChain([query, 'access', _ => _.viewer, 'access', _2 => _2.teamMember, 'optionalAccess', _3 => _3.integrations, 'access', _4 => _4.gitlab, 'access', _5 => _5.api, 'optionalAccess', _6 => _6.query, 'optionalAccess', _7 => _7.projects, 'optionalAccess', _8 => _8.edges]), () => ( []))
  const projects = useMemo(() => getNonNullEdges(nullableEdges).map(({node}) => node), [query])
  const meeting = _optionalChain([query, 'optionalAccess', _9 => _9.viewer, 'optionalAccess', _10 => _10.meeting])
  const meetingId = _nullishCoalesce(_optionalChain([meeting, 'optionalAccess', _11 => _11.id]), () => ( ''))
  const gitlabSearchQuery = _optionalChain([meeting, 'optionalAccess', _12 => _12.gitlabSearchQuery])
  const {selectedProjectsIds} = gitlabSearchQuery
  const atmosphere = useAtmosphere()

  const {
    query: searchQuery,
    filteredItems: filteredProjects,
    onQueryChange
  } = useSearchFilter(projects, getValue)
  const visibleProjects = filteredProjects.slice(0, MAX_PROJECTS)

  const {portalStatus, isDropdown} = menuProps
  return (
    React.createElement(StyledMenu, {
      keepParentFocus: true,
      ariaLabel: "Define the GitLab search query"    ,
      portalStatus: portalStatus,
      isDropdown: isDropdown,}

      , React.createElement(SearchMenuItem, {
        placeholder: "Search GitLab projects"  ,
        onChange: onQueryChange,
        value: searchQuery,}
      )
      , visibleProjects.length === 0 && (
        React.createElement(EmptyDropdownMenuItemLabel, { key: "no-results",}, "No projects found!"  )
      )
      , visibleProjects.map((project) => {
        const {id: projectId, fullPath} = project
        const isSelected = !!_optionalChain([selectedProjectsIds, 'optionalAccess', _13 => _13.includes, 'call', _14 => _14(projectId)])

        const handleClick = () => {
          commitLocalUpdate(atmosphere, (store) => {
            const searchQueryId = SearchQueryId.join('gitlab', meetingId)
            const gitlabSearchQuery = store.get(searchQueryId)
            const selectedProjectsIds = gitlabSearchQuery.getValue(
              'selectedProjectsIds'
            ) 
            const newSelectedProjectsIds = isSelected
              ? selectedProjectsIds.filter((id) => id !== projectId)
              : [...selectedProjectsIds, projectId]
            gitlabSearchQuery.setValue(newSelectedProjectsIds, 'selectedProjectsIds')
          })
          SendClientSideEvent(atmosphere, 'Selected Poker Scope Project Filter', {
            meetingId,
            projectId,
            service: 'gitlab'
          })
        }
        return (
          React.createElement(MenuItem, {
            key: projectId,
            label: 
              React.createElement(StyledMenuItemLabel, null
                , React.createElement(StyledCheckBox, { active: isSelected,} )
                , React.createElement(TypeAheadLabel, { query: searchQuery, label: fullPath,} )
              )
            ,
            onClick: handleClick,}
          )
        )
      })
    )
  )
}

export default GitLabScopingSearchFilterMenu
